export const getCurrentReferencePeriodId = (referencePeriods) => {
  return Math.max(...referencePeriods.map(({ value }) => value))
}
